var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-resize-container",style:({maxWidth: _vm.maxWidth})},[_c('div',{staticClass:"iframe-content"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.attributes.value,"frameborder":"0","scrolling":"no"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }